import {combineReducers} from 'redux';
import authReducer from './auth.reducer';
import dashboardReducer from './dashboard.reducer';
import userReducer from './user.reducer';
import agentReducer from './agent.reducer';
import campaignReducer from './campaign.reducer';
import lineReducer from './line.reducer';
import reportReducer from './report.reducer';
import companyReducer from './company.reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  dashboard: dashboardReducer,
  agent: agentReducer,
  campaign: campaignReducer,
  line: lineReducer,
  report: reportReducer,
  company: companyReducer,
});

export default rootReducer;
